// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vo-8";
export var editMode = "_vo-3";
export var headerRow = "_vo-a";
export var headerTitle = "_vo-b";
export var product = "_vo-1";
export var productDetails = "_vo-5";
export var productDivider = "_vo-7";
export var productImage = "_vo-2";
export var productInfo = "_vo-4";
export var productTitle = "_vo-6";
export var strikethrough = "_vo-9";
export var upsellProductsCard = "_vo-0";